import { RematchDispatch } from '@rematch/core';
import { axiosErrorHandler } from 'common/helpers';
import { IRootModel } from 'app/store';
import { historyListService } from 'entities/History/History.service';

export const historyListEffects = (dispatch: RematchDispatch<IRootModel>) => ({
  async getHistory(eventId: number) {
    dispatch.historyList.setLoading(true);

    try {
      const response = await historyListService.getHistory(eventId);
      dispatch.historyList.setList(response.data);
    } catch (error) {
      axiosErrorHandler(error);
    } finally {
      dispatch.historyList.setLoading(false);
    }
  },
});
